import { NgModule } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { UserComponent } from 'app/layout/common/user/user.component';
import { SharedModule } from 'app/shared/shared.module';
import { TsButtonModule, TSIconModule } from 'tsui';

@NgModule({
  declarations: [UserComponent],
  imports: [TsButtonModule, MatDividerModule, MatIconModule, MatMenuModule, SharedModule, TSIconModule],
  exports: [UserComponent],
})
export class UserModule {}
